const formatters: Record<string, Intl.NumberFormat> = {
    EUR: new Intl.NumberFormat('hu-HU', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0,
    }),
    HUF: new Intl.NumberFormat('hu-HU', {
        style: 'currency',
        currency: 'HUF',
        maximumFractionDigits: 0,
    }),
    GBP: new Intl.NumberFormat('hu-HU', {
        style: 'currency',
        currency: 'GBP',
        maximumFractionDigits: 0,
    }),
    USD: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
    }),
};

const getFormatter = (currency: string): Intl.NumberFormat => {
    if (!formatters[currency]) {
        formatters[currency] = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency,
            maximumFractionDigits: 0,
        });
    }
    return formatters[currency];
};

const formatMoney = (value: number, currency: string) =>
    getFormatter(currency).format(value);

export default formatMoney;
